import { TeamRepository } from '../repositories';

export class DeleteTeamUseCase {
  constructor(private teamRepository: TeamRepository) {}

  async execute(teamId: string): Promise<void> {
    await this.teamRepository.delete(teamId);
  }
}
